module.exports = __webpack_public_path__ + "img/zammit.255ec9d3.svg";